import script from "./button-submit.vue?vue&type=script&setup=true&lang=ts"
export * from "./button-submit.vue?vue&type=script&setup=true&lang=ts"

import "./button-submit.vue?vue&type=style&index=0&id=6e3e777f&lang=scss"

const __exports__ = script;

export default __exports__